export const focus = {
  mounted(el) {
    el.focus();
  },
};